import React from 'react';
import { ChefHat } from 'lucide-react';

const recipes = [
  {
    id: 1,
    title: 'Butter Chicken',
    difficulty: 'Medium',
    time: '45 mins',
    image: 'https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
  },
  {
    id: 2,
    title: 'Palak Paneer',
    difficulty: 'Easy',
    time: '30 mins',
    image: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
  },
  {
    id: 3,
    title: 'Masala Dosa',
    difficulty: 'Hard',
    time: '60 mins',
    image: 'https://images.unsplash.com/photo-1589301760014-d929f3979dbc?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
  }
];

export default function Recipes() {
  return (
    <section className="py-12">
      <div className="container mx-auto px-4">
        <div className="flex items-center gap-2 mb-8">
          <ChefHat className="text-[#568203]" size={24} />
          <h2 className="text-3xl font-bold text-gray-800">Featured Recipes</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {recipes.map((recipe) => (
            <div key={recipe.id} className="bg-white rounded-lg shadow-md overflow-hidden">
              <img src={recipe.image} alt={recipe.title} className="w-full h-48 object-cover" />
              <div className="p-4">
                <h3 className="text-xl font-semibold mb-2">{recipe.title}</h3>
                <div className="flex justify-between text-sm text-gray-600">
                  <span>Difficulty: {recipe.difficulty}</span>
                  <span>Time: {recipe.time}</span>
                </div>
                <button className="mt-4 w-full bg-[#568203] text-white py-2 rounded-md hover:bg-[#476c02] transition-colors">
                  View Recipe
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}